import React from 'react';
import { LocationPage } from './useLocationPage';
import './useLocationPage.css';

// ─── Images ───────────────────────────────────────────────────────────────────
// Swap out any of these for Sarasota-specific shots
import heroImg   from '../images/tampa3.webp';
import bgImg     from '../images/image8.webp';
import slideImg1 from '../images/image121.webp';
import slideImg2 from '../images/image117.webp';
import slideImg3 from '../images/image50.webp';

// ─── Config ───────────────────────────────────────────────────────────────────
const templeTerraceConfig = {

  /* ── SEO ────────────────────────────────────────────────────────────────── */
  pageTitle:       'Temple Terrace Tree Service | Sam\'s Tree Service',
  metaDescription: 'Professional tree trimming and removal in Temple Terrace, FL. Sam\'s Tree Service handles dangerous trees safely and affordably.',
  canonicalUrl:    'https://samstreeservice.com/tree_service_temple_terrace',

  /* ── Hero ───────────────────────────────────────────────────────────────── */
  heroHeading: 'Serving Temple Terrace',
  heroImageUrl: heroImg,
  bgImageUrl:   bgImg,

  /* ── Slide images ───────────────────────────────────────────────────────── */
  slideImage1: slideImg1,
  slideImage2: slideImg2,
  slideImage3: slideImg3,

  /* ── Main text panel ────────────────────────────────────────────────────── */
  sectionHeading: 'Professional Tree Service in Temple Terrace Specializing In Dangerous Trees',
  
  paragraphs: [
    `At <strong>Sam's Tree Service</strong>, we bring professional tree care to the 
     golf course community and established neighborhoods of <strong>Temple Terrace</strong>. 
     Enormous oaks and mature canopy trees are part of what makes this city feel 
     distinct but they also require consistent expert management to stay safe. 
     As trees age and storms roll through, overhanging limbs and weakened trunks 
     become real threats to the homes and properties below.`,

    `We specialize in <strong>large tree trimming and hazardous removal in mature 
     residential settings</strong> storm split oaks, heavy canopy overhangs near 
     homes and garages, trees with root damage from years of growth near pavement, 
     and full removals where trees have become too dangerous to manage. We work 
     carefully and clean up completely.`,

    `<strong>Sam's Tree Service</strong> provides trusted, expert tree care 
     throughout <strong>Temple Terrace</strong> and the surrounding 
     <strong>Northeast Tampa</strong> area protecting your property and 
     preserving the beautiful canopy that defines this community.`,
  ],
  ctaLabel: 'Request An Appointment',

  /* ── Service buttons (optional — defaults to the 4 standard ones) ────────── */
  // serviceButtons: [
  //   { label: 'Tree Trimming', to: '/tree_trimming' },
  //   { label: 'Tree Removal',  to: '/tree_removal'  },
  //   { label: 'Stump Removal', to: '/stump_removal'  },
  //   { label: 'Debris Hauling',to: '/debris_hauling' },
  // ],

  /* ── Google Map ─────────────────────────────────────────────────────────── */
  mapCity: 'Temple Terrace, FL',
};

// ─── Page ─────────────────────────────────────────────────────────────────────
const Services_TempleTerrace = () => <LocationPage config={templeTerraceConfig} />;
export default Services_TempleTerrace;
